export default "__VITE_ASSET__73f5ce0b__"